module.exports = __webpack_public_path__ + "static/media/tipo1.7945f1a0.png";